import UserCardSmall from 'ui/components/UserCardSmall/'
import UserStatusControl from 'ui/components/UserStatusControl'
import {
  UserListStyled,
  UserListTitle,
  UserListGrid,
  UserElem,
  UserCard,
} from './styled'

const UserList = ({
  users,
  title,
  onCloseHandler,
  activeManagersCount,
  changingUserId,
  onStatusChange,
  canEditProjectSettings,
}) => (
  <UserListStyled>
    <UserListTitle>{title}</UserListTitle>

    <UserListGrid>
      {users.map((user) => {
        const { id, name, surname, role, avatar } = user

        return (
          <UserElem key={id}>
            <UserCard>
              <UserCardSmall
                handler={onCloseHandler}
                href={`/users/${id}`}
                name={`${surname} ${name}`}
                additionalText={role?.map((role) => role?.name)}
                avatar={avatar?.link}
                isApi={avatar?.is_api}
              />
            </UserCard>

            {canEditProjectSettings && (
              <UserStatusControl
                user={user}
                activeManagersCount={activeManagersCount}
                isStatusChanging={changingUserId === id}
                onStatusChange={onStatusChange}
              />
            )}
          </UserElem>
        )
      })}
    </UserListGrid>
  </UserListStyled>
)

export default UserList
